import { Route } from "@angular/router";
import { DashboardComponent } from '@modules/dashboard/components/dashboard/dashboard.component';

//The DashboardComponent routes shouldn't require case selection because 
//the component has special logic to route to Participant/Search when 
//no dashboards are available
export const DASHBOARD_ROUTES: Route[] = [
    {
        path: '',
        component: DashboardComponent,
        title: 'HRally - Dashboards'
    },
    {
        path: ':dashboardName',
        component: DashboardComponent,
        title: 'HRally - Dashboards'
    }
];
